<rr-start-logo color="inverse"></rr-start-logo>
<div class="col innerelement">
  <h1 class="w100" i18n>Use mobile?</h1>
  <p i18n>
    This website is not for mobile use. If you want to use our Software please
    use a Desktop.
  </p>
  <!-- <div class="storerow col w100">
    <a
      href="https://play.google.com/store/apps/details?id=com.rr.rrapp"
      target="_blank"
    >
      <img src="images/google_store_badge.webp" alt="Google Play Store" />
    </a>
    <a href="https://apps.apple.com/us/app/rrapp/id1531160000" target="_blank">
      <img src="images/app_store_badge.png" alt="Apple App Store" />
    </a>
  </div> -->
</div>
